import React from 'react';
import style from '@src/js/Style';
import PropTypes from 'prop-types';

export default class SkeletonText extends React.Component {

    constructor(props) {

        super(props);

        this.blockRef = React.createRef();
        this.state = {
            content: null,
        };
    }

    static get propTypes() {

        return {
            children: PropTypes.any,
            className: PropTypes.string,
            skeletonClassName: PropTypes.string,
            skeletonGroupClassName: PropTypes.string,
            animationOnly: PropTypes.bool,
            rows: PropTypes.number,
            size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            style: PropTypes.object,
        };
    }

    render() {

        const classes = [];

        if (this.props.className != undefined)
            classes.push(this.props.className);

        if (this.isActive) {

            return <div className={ classes.join(' ') }>{ this.getContent() }</div>;
        }
        else {

            if (this.props.skeletonGroupClassName != undefined)
                classes.push(this.props.skeletonGroupClassName);

            const skeletonClasses = [ style('pulse cursor-progress') ];
            if (this.props.skeletonClassName != undefined)
                skeletonClasses.push(this.props.skeletonClassName);

            if (!this.props.animationOnly)
                skeletonClasses.push(style('bg-gray rounded'));

            if (this.props.rows ?? 1 > 1)
                skeletonClasses.push(style('mb-1'));

            const
                className = skeletonClasses.join(' '),
                rows = Array(this.props.rows ?? 1)
                    .fill(null)
                    .map((value, index) => <div key={ index } className={ className }>&nbsp;</div>);

            const styles = this.props.styles ?? {};
            if (this.props.size != undefined) {
                
                styles['width'] = /[^\d]/.test(this.props.size)
                    ? this.props.size
                    : `${this.props.size}px`;
            }
            if (this.props.height != undefined) {
                
                styles['height'] = /[^\d]/.test(this.props.height)
                    ? this.props.height
                    : `${this.props.height}px`;
            }

            return <div className={ classes.join(' ') } style={ styles }>{ rows }</div>;
        }
    }

    get isActive() {

        if (this.props.when)
            return this.props.when();

        return (this.getContent() != null);
    }

    getContent() {

        return this.state.content ?? this.props.children;
    }

    setContent(content) {

        this.setState({ content });
    }

}